import { Link } from "react-router-dom";
import useStoreSettings from "@/hooks/useStoreSettings";

const staticEntries = [
  {
    label: "體驗認購",
    desc: "限時特惠好貨",
    href: "/products?region=體驗認購區",
    external: false,
    image: "https://readdy.ai/api/search-image?query=A%20minimal%203D%20isometric%20illustration%20of%20a%20shopping%20bag%20with%20gift%20boxes%20and%20small%20sparkles%20floating%20around%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20soft%20clean%20white%20background%2C%20soft%20shadows%2C%20modern%20UI%20icon%20style%2C%20high%20quality%203D%20render%2C%20cute%20and%20friendly%20aesthetic%2C%20clean%20design&width=200&height=200&seq=1&orientation=squarish",
  },
  {
    label: "我的訂單",
    desc: "查看配送進度",
    href: "/dashboard/orders",
    external: false,
    image: "https://readdy.ai/api/search-image?query=A%20minimal%203D%20isometric%20illustration%20of%20a%20delivery%20cardboard%20package%20box%20with%20shipping%20label%20and%20small%20checkmark%20badge%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20soft%20clean%20white%20background%2C%20soft%20shadows%2C%20modern%20UI%20icon%20style%2C%20high%20quality%203D%20render%2C%20cute%20and%20friendly%20aesthetic%2C%20clean%20design&width=200&height=200&seq=2&orientation=squarish",
  },
  {
    label: "新手說明",
    desc: "快速上手分銷",
    href: "/guide",
    external: false,
    image: "https://readdy.ai/api/search-image?query=A%20minimal%203D%20isometric%20illustration%20of%20an%20open%20book%20with%20bookmark%20and%20small%20glowing%20lightbulb%20on%20top%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20soft%20clean%20white%20background%2C%20soft%20shadows%2C%20modern%20UI%20icon%20style%2C%20high%20quality%203D%20render%2C%20cute%20and%20friendly%20aesthetic%2C%20clean%20design&width=200&height=200&seq=3&orientation=squarish",
  },
  {
    label: "儲值下單",
    desc: "線上快速儲值",
    href: "/dashboard/recharge",
    external: false,
    image: "https://readdy.ai/api/search-image?query=A%20minimal%203D%20isometric%20illustration%20of%20a%20golden%20wallet%20with%20coins%20and%20credit%20card%20floating%20around%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20soft%20clean%20white%20background%2C%20soft%20shadows%2C%20modern%20UI%20icon%20style%2C%20high%20quality%203D%20render%2C%20cute%20and%20friendly%20aesthetic%2C%20clean%20design&width=200&height=200&seq=4&orientation=squarish",
  },
];

export default function QuickEntry() {
  const { lineUrl } = useStoreSettings();

  const entries = [
    ...staticEntries,
    {
      label: "聯繫團長",
      desc: "LINE 一對一服務",
      href: lineUrl,
      external: true,
      image: "https://readdy.ai/api/search-image?query=A%20minimal%203D%20isometric%20illustration%20of%20a%20friendly%20customer%20service%20headset%20with%20speech%20bubble%20and%20small%20heart%20shape%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20soft%20clean%20white%20background%2C%20soft%20shadows%2C%20modern%20UI%20icon%20style%2C%20high%20quality%203D%20render%2C%20cute%20and%20friendly%20aesthetic%2C%20clean%20design&width=200&height=200&seq=5&orientation=squarish",
    },
  ];

  return (
    <section className="py-10 px-4 sm:px-6 lg:px-12 bg-white">
      <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-6 gap-3 sm:gap-4">
        {entries.map((entry) => {
          const content = (
            <div className="flex flex-col items-center gap-2 sm:gap-2.5 p-3 sm:p-4 rounded-2xl bg-white shadow-[0_2px_12px_rgba(0,0,0,0.06)] hover:shadow-[0_4px_20px_rgba(0,0,0,0.1)] border border-gray-100/60 hover:border-amber-200/60 transition-all duration-300 cursor-pointer group">
              <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full overflow-hidden bg-amber-50 ring-1 ring-amber-100 group-hover:ring-amber-300 group-hover:scale-110 transition-all duration-300">
                <img
                  src={entry.image}
                  alt={entry.label}
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="text-xs sm:text-sm font-semibold text-gray-900 whitespace-nowrap mt-0.5">
                {entry.label}
              </span>
              <span className="text-[10px] sm:text-xs text-gray-400 whitespace-nowrap hidden sm:block">
                {entry.desc}
              </span>
            </div>
          );

          return entry.external ? (
            <a
              key={entry.label}
              href={entry.href}
              target="_blank"
              rel="noopener noreferrer"
              className="block"
            >
              {content}
            </a>
          ) : (
            <Link
              key={entry.label}
              to={entry.href}
              className="block"
            >
              {content}
            </Link>
          );
        })}
      </div>
    </section>
  );
}